import React, { useEffect, useState } from "react";
import Partner from "../partners/profile/Partner";
import ClientProfile from "../clients/profile/ClientProfile";
import { API_URL, authFetch } from "../utils/auth";

export default function Profile({ partner }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const role = localStorage.getItem("portal_role") || "client";
  const isEmployee = partner || localStorage.getItem("is_internal") === "true" || role !== "client";
  const profileEndpoint = partner ? `${API_URL}/partner/profile/` : isEmployee ? `${API_URL}/employee/profile/` : `${API_URL}/client/profile/`;

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);

        const endpoint = profileEndpoint;

        const res = await authFetch(endpoint);

        if (!res.ok) {
          throw new Error("Failed to load profile");
        }

        const json = await res.json();
        setData(json);

      } catch (err) {
        console.error("Profile load error:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [profileEndpoint]);

  return (
    <>
      {isEmployee ? (
        <Partner data={data} loading={loading} profileEndpoint={profileEndpoint} />
      ) : (
        <ClientProfile data={data} loading={loading} />
      )}
    </>
  );
}